module.exports = __webpack_public_path__ + "img/report-9.44135ac4.jpg";